import { apolloClient } from "@/plugins/apollo";

export const apolloPlugin = store => {
	store.watch(
		(_state, getters) => getters["auth/signedIn"],
		signedIn => {
			console.debug(
				`User signed ${signedIn ? "in" : "out"}: resetting apollo state`
			);
			return apolloClient.resetStore();
		}
	);
};
